module.exports = _.mapKeys;